import {useState, createContext, useEffect} from 'react';
import api from '../config.js';
import { toast } from 'react-toastify';
import { showMessageError } from '../classes/functions.js';

export const AuthContext = createContext({});

function AuthProvider({ children }) {
  const [user, setUser] = useState(null);//User informations
  const [loadingAuth, setLoadingAuth] = useState(false);
  const [loading, setLoading] = useState(true);
  const [companies, setCompanies] = useState([]);
  const [companiesSelected, setCompaniesSelected] = useState('');

  useEffect(()=>{

    function loadStorage(){
      const storageUser = localStorage.getItem('SistemUser');

      if(storageUser){
        setUser(JSON.parse(storageUser));
        setLoading(false);
      }
  
      setLoading(false);
    }
    
    loadStorage();

  }, [])

  async function login(data){
    setLoadingAuth(true);
    
    api.post("/api/login", data).then((response) => {
      storageUser(response.data.row);
      setUser(response.data.row);
      setCompanieUser(response.data.row.empresas[0].id);
      localStorage.setItem('usuario', response.data.row.id);
      localStorage.setItem('nome_usuario', response.data.row.nome);
      localStorage.setItem('permissoes', response.data.row.permissoes);
      setLoadingAuth(false);

      toast.success('Seja bem-vindo');
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function storageUser(data){
    localStorage.setItem('SistemUser', JSON.stringify(data));
    
  }

  function setCompanieUser(data){
    setCompaniesSelected(data);
    localStorage.setItem('empresa', data);
    localStorage.setItem('parametros', data);

    window.location.reload();
  }

  //Logout do usuario
  async function signOut(){
    localStorage.removeItem('SistemUser');
    setUser(null);
  }

  return(
    <AuthContext.Provider 
      value={{ 
          signed: !!user,  
          user, 
          loading,
          login,
          signOut,
          loadingAuth,
          companiesSelected,
          setCompanieUser
        }}
      >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthProvider;